import { request } from '../../services/request'

export async function getSubscriptionSearchResults(partnerId: string, text: string, includeDeactivated: boolean) {

  const qryParams = {
    'filter': `name~=${text}`,
    'limit': '5',
    'page': '1',
    'sort' : 'name',
    'include': 'reseller' + (includeDeactivated ? ',deactivated' : '')
  }

  const response = await request({
    path: `/resellers/${partnerId}/subscriptions?${new URLSearchParams(qryParams)}`,
    method: 'get'
  })

  return response
}

export async function getPagedSubscriptionSearchResults(partnerId: string, text: string, includeDeactivated: boolean, page: number, sort: string) {
  const qryParams = {
    'filter': `name~=${text}`,
    'limit': '25',
    'page': `${page}`,
    'sort' : sort,
    'include': 'reseller,stats,package' + (includeDeactivated ? ',deactivated' : '')
  }

  const response = await request({
    path: `/resellers/${partnerId}/subscriptions?${new URLSearchParams(qryParams)}`,
    method: 'get'
  })

  return response
}

export async function getAccountSearchResults(partnerId: string, text: string, includeDeactivated: boolean) {

  const qryParams = {
    'filter': `name~=${text}`,
    'limit': '5',
    'page': '1',
    'role': 'employee',
    'sort' : 'name',
    'include': 'subscription' + (includeDeactivated ? ',deactivated' : '')
  }

  const response = await request({
    path: `/resellers/${partnerId}/accounts?${new URLSearchParams(qryParams)}`,
    method: 'get'
  })

  return response
}

export async function getAccount(id: string) {
  const response = await request({
    path: `/accounts/${id}?include=subscription`,
    method: 'get'
  })

  return response
}

